import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import { CommonSite } from '@awaze/mfe-common.types-and-mocks.site-search-service'
import { decode } from 'html-entities'
import { useEffect, useState } from 'react'
import { PropertyInfoResponse } from 'src/utils/getPropertyInfo'
import { modifyPropertyImages } from '../DynamicMap.utils'

interface UsePropertyInfoProps {
  brand: Brand
  isDatedSearch: boolean
  getPropertyInfo: (propertyId: string) => Promise<PropertyInfoResponse>
}

export const usePropertyInfo = ({
  brand,
  getPropertyInfo,
  isDatedSearch,
}: UsePropertyInfoProps): {
  activeMarkerId: string | null
  isPropertyInfoError: boolean
  onMarkerClick: (markerId: string) => void
  propertyInfo: CommonSite | null
  setActiveMarkerId: (markerId: string | null) => void
} => {
  const [activeMarkerId, setActiveMarkerId] = useState<string | null>(null)
  const [propertyInfo, setPropertyInfo] = useState<CommonSite | null>(null)
  const [isPropertyInfoError, setIsPropertyInfoError] = useState(false)

  useEffect(() => {
    activeMarkerId &&
      getPropertyInfo(activeMarkerId).then((result) => {
        if (!result.property) {
          setIsPropertyInfoError(true)
          return
        }

        let modifiedImages = undefined
        if (Array.isArray(result.property.images)) {
          modifiedImages = modifyPropertyImages(result.property.images)
        }

        const propertyWithModifiedImages = {
          ...result.property,
          images: modifiedImages,
        }

        if (propertyWithModifiedImages.displayName !== undefined) {
          propertyWithModifiedImages.displayName = decode(
            propertyWithModifiedImages.displayName,
          )
        }

        if (
          !isDatedSearch &&
          (brand === 'cottages.com' || brand === 'hoseasons')
        ) {
          delete propertyWithModifiedImages.wasPrice
          delete propertyWithModifiedImages.startDate
        }

        setPropertyInfo(propertyWithModifiedImages)
      })
  }, [activeMarkerId])

  const onMarkerClick = (markerId: string) => {
    if (activeMarkerId !== markerId) {
      setIsPropertyInfoError(false)
      setPropertyInfo(null)
      setActiveMarkerId(markerId)
    }
  }

  return {
    activeMarkerId,
    isPropertyInfoError,
    onMarkerClick,
    propertyInfo,
    setActiveMarkerId,
  }
}
